<div class="text">
  <p>{{ 'RESOURCE_EDIT' | translate: { displayName: displayName } }}</p>
</div>

<form
  class="form-container"
  [formGroup]="editResourceForm"
  (ngSubmit)="onSubmit()"
>
  <mat-form-field>
    <mat-label>{{ 'Resource Name' | translate }}</mat-label>
    <input matInput id="name" type="text" formControlName="name" />
  </mat-form-field>

  <div class="inline-info">
    <mat-form-field class="inline-form">
      <mat-label>{{ 'Primary Owner' | translate }}</mat-label>
      <input
        type="text"
        matInput
        [placeholder]="'Search for a primary owner' | translate"
        [formControlName]="'primaryOwner' | translate"
        [matAutocomplete]="primaryAuto"
      />
      <mat-autocomplete
        #primaryAuto="matAutocomplete"
        [displayWith]="displayUserFn"
        (optionSelected)="onPrimaryOwnerSelected($event)"
      >
        @for (person of filteredPrimaryOwner | async; track person.id) {
          <mat-option [value]="person">
            {{ person.displayName }} ({{ person.userPrincipalName }})
          </mat-option>
        }
      </mat-autocomplete>
      <mat-error>
        {{
          ownerErrorMessage(primaryOwnerControl, 'Primary Owner is required')
            | translate
        }}
      </mat-error>
    </mat-form-field>
    <i
      ><img
        class="infobutton"
        src="../../../assets/icons/Information-Circle--Streamline-Ultimate.svg"
        alt="Info"
        [matTooltip]="
          'If you select a new Primary Owner you can no longer renew the lifecycle. You won\'t loose access to the resource.'
            | translate
        "
    /></i>
  </div>

  <div class="inline-info">
    <mat-form-field class="inline-form">
      <mat-label>{{ 'Secondary Owner' | translate }}</mat-label>
      <input
        type="text"
        matInput
        [placeholder]="'Search for a secondary owner' | translate"
        [formControlName]="'secondaryOwner' | translate"
        [matAutocomplete]="secondaryAuto"
      />
      <mat-autocomplete
        #secondaryAuto="matAutocomplete"
        [displayWith]="displayUserFn"
        (optionSelected)="onSecondaryOwnerSelected($event)"
      >
        @for (person of filteredSecondaryOwner | async; track person.id) {
          <mat-option [value]="person">
            {{ person.displayName }} ({{ person.userPrincipalName }})
          </mat-option>
        }
      </mat-autocomplete>
      <mat-error>
        {{
          ownerErrorMessage(
            secondaryOwnerControl,
            'Please select a valid user from the dropdown list'
          ) | translate
        }}
      </mat-error>
    </mat-form-field>
    <i
      ><img
        class="infobutton"
        src="../../../assets/icons/Information-Circle--Streamline-Ultimate.svg"
        alt="Info"
        [matTooltip]="
          'The Secondary Owner can also renew the lifecycle of a resource.'
            | translate
        "
    /></i>
  </div>

  <hr />
  <div class="form-footer">
    <div class="form-nav"></div>
    <div class="submit">
      <button
        mat-flat-button
        color="primary"
        [disabled]="!editResourceForm.valid"
      >
        {{ 'Send' | translate }}
      </button>
    </div>
  </div>
</form>
